import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/modules/auth/store/auth.store";
import { ThemeToggle } from "@/shared/components/ui";

export function AuthLayout() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	// If already authenticated, redirect to dashboard
	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<div className="auth-backdrop relative flex min-h-screen flex-col">
			<div className="absolute right-4 top-4 z-10">
				<ThemeToggle />
			</div>

			<main className="flex flex-1 items-center justify-center px-4 py-10">
				<Outlet />
			</main>

			<footer className="pb-6 text-center text-xs text-[var(--c-text-muted)]">
				Murojaat — yordam taqsimotini boshqarish tizimi
			</footer>
		</div>
	);
}
